import { render, staticRenderFns } from "./TabsControl.vue?vue&type=template&id=4976c1e4&scoped=true"
import script from "./TabsControl.vue?vue&type=script&lang=js"
export * from "./TabsControl.vue?vue&type=script&lang=js"
import style0 from "./TabsControl.vue?vue&type=style&index=0&id=4976c1e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4976c1e4",
  null
  
)

export default component.exports